import { login, logout, getInfo, reguser } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import bcrypt from 'bcryptjs'
import linq from 'linq'

const state = {
    username: '',
    userid: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    forms: [],
    pdabills: [],
    isadmin: false
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_FORMS: (state, forms) => {
        state.forms = forms
    },
    SET_PDABILLS: (state, pdabills) => {
        state.pdabills = pdabills
    },
    SET_USERNAME: (state, username) => {
        state.username = username
    },
    SET_USREID: (state, userid) => {
        state.userid = userid
    },
    SET_ISADMIN: (state, isadmin) => {
        state.isadmin = isadmin
    },
}

const actions = {
  // user login
  login({ commit, dispatch }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
        var salt = bcrypt.genSaltSync(12)
        var date = new Date().getTime()
        var hash = bcrypt.hashSync(date + ':' + username.trim().toLowerCase() + ':' + password, salt)

        login({ name: username.trim(), password: hash, date: date }).then(response => {
            const { token, forms, formgroups, pdabills } = response
            commit('SET_TOKEN', token)
            commit('SET_USERNAME', username)
            commit('SET_USREID', response.userinfo.ID)
            commit('SET_FORMS', linq.from(formgroups).select(p => {
                p.children = linq.from(forms).where(q => q.groupId === p.id).toArray()
                return p
            }).where(p => p.children.length > 0).orderBy(p => p.pos).toArray())
            commit('SET_PDABILLS', pdabills)
            setToken(token)
            resolve()
        }).catch(error => {
            reject(error)
        })
    })
  },
  reguser({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
        reguser(userInfo).then(response => {
            resolve()
        }).catch(error => {
            reject(error)
        })
    })
  },
  // get user info
  getInfo({ commit, state }) {
    if (!state.username) {
        return new Promise((resolve, reject) => {
            reject('获取用户信息失败。请重新登陆。')
        })
    }
    return new Promise((resolve, reject) => {
      getInfo({
        username: state.username
      }).then(response => {
        const { data } = response

        if (!data || data.length === 0) {
          reject('获取用户信息失败。请重新登陆。')
        }
        const type = data[0].Type
        const roles = response.roles
        console.log(roles)
        if (type === 1) {
            // 管理员
        } else {
            // 普通用户
            if (roles.length==0) {
                reject('获取用户权限失败。请重新登陆。')
            }
        }
        commit('SET_ISADMIN', type === 1)
        commit('SET_ROLES', roles ? roles : [])
        commit('SET_NAME', data[0].Name)
        commit('SET_AVATAR', data[0].Avatar)
        commit('SET_INTRODUCTION', data[0].Introduction)
        resolve({
            roles: roles ? roles : [],
            forms: state.forms,
            pdabills: state.pdabills ? state.pdabills : [],
            userinfo: data[0]
        })
      }).catch(error => {
        reject(error)
      })
    })
  },
  setavatar({ commit }, avatar) {
    commit('SET_AVATAR', avatar)
  },
  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles, forms } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', { roles, forms, root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
